import FadeIn from "../ui/FadeIn";
import { STATS } from "../../data/constants";
import styles from "./StatsStrip.module.css";

export default function StatsStrip() {
  return (
    <div className={styles.band}>
      <div className={styles.grid}>
        {STATS.map(({ n, s, label }, i) => (
          <FadeIn key={label} delay={i * 0.1}>
            <div className={styles.stat}>
              <div className={styles.number}>
                {n}<span className={styles.suffix}>{s}</span>
              </div>
              <div className={styles.label}>{label}</div>
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  );
}
